"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { api, setAuth, getToken, getUser } from "@/lib/api";
import { AuthShell, inputStyle, btnStyle, labelStyle } from "@/components/AuthShell";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const token = getToken();
    if (!token) return;
    const user = getUser();
    window.location.replace(user?.is_admin ? "/admin" : "/chat");
  }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const res = await api<{ access_token: string; user: any }>("/auth/login", {
        method: "POST",
        body: JSON.stringify({ username, password }),
      });
      setAuth(res.access_token, res.user);
      window.location.replace(res.user.is_admin ? "/admin" : "/chat");
    } catch (e: any) {
      setErr(e.message || "登录失败");
    } finally {
      setLoading(false);
    }
  }

  if (!mounted) {
    return <AuthShell title="登录" subtitle="登录后即可向我提问" />;
  }

  return (
    <AuthShell title="登录" subtitle="登录后即可向我提问">
      <form onSubmit={submit}>
        <label style={labelStyle}>用户名</label>
        <input
          style={inputStyle}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="请输入用户名"
          autoComplete="username"
        />
        <label style={labelStyle}>密码</label>
        <input
          style={inputStyle}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="请输入密码"
          autoComplete="current-password"
        />
        {err && (
          <div style={{ color: "#ff8a8a", fontSize: 13, marginBottom: 12 }}>{err}</div>
        )}
        <button style={btnStyle} disabled={loading}>
          {loading ? "登录中…" : "登录"}
        </button>
      </form>
      <div style={{ marginTop: 16, fontSize: 14, color: "var(--muted)" }}>
        还没有账号？{" "}
        <Link href="/register" style={{ color: "var(--accent)" }}>
          去注册
        </Link>
      </div>
    </AuthShell>
  );
}
